import * as React from 'react';

function SvgComponent({ isSelected, ...props }) {
    return (
        <svg
            width={46}
            height={38}
            viewBox="0 0 46 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={0.5} y={0.5} width={45} height={37} rx={5.5} fill="#fff" />
            <rect
                x={0.5}
                y={0.5}
                width={45}
                height={37}
                rx={5.5}
                stroke={isSelected ? '#2C87F3' : '#999'}
            />
            <path
                transform="translate(8 10)"
                fill={isSelected ? '#2C87F3' : '#999'}
                d="M0 0H30V18H0z"
            />
        </svg>
    );
}

export default SvgComponent;
